
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import BtnCheckGroup from "@common/src/components/scope/btn-check-group/index.vue";
import dayjs from "dayjs";
import t from "@common/src/i18n/t";
import { addCurrencyUnit } from "@common/src/utils/tools";
import CustomerFlag from "@common/src/components/scope/customer-flag/index.vue";
import CustomerFlagSelect from "@common/src/components/scope/flag-select/index.vue";
import { mobileRules, checkMoneyEl } from "@common/src/utils/verify";
import PartsGroupPreview from "@common/src/views/setting/components/parts-group-preview.vue";

const customer = namespace("customer");
const user = namespace("user");
const app = namespace("app");
const base = namespace("base");
const marketing = namespace("marketing");
const setting = namespace("setting");

@Component({
  components: { BtnCheckGroup, CustomerFlag, CustomerFlagSelect, PartsGroupPreview }
})
export default class CardOpen extends Vue {
  @app.Mutation setPBPX;
  @customer.Action getCustomerList;
  @customer.Action getCustomerDetail;
  @marketing.Action queryCardTemplateList;
  @marketing.Action queryCardTemplateDetail;
  @marketing.Action validateAddCard;
  @marketing.Action createCard;
  @marketing.Action queryCustomerCard;
  @base.Action getDictionaryList;
  @user.State userData;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  @setting.Action getPatternPaymentList;
  dayjs = dayjs;
  splitThousands = splitThousands;
  addCurrencyUnit = addCurrencyUnit;
  showPaymentMethod: boolean = false;
  showOpenCardValidate: boolean = false;
  openCardValidateMsg: string = "";
  paymentMethod: string = "";
  get breadData() {
    return [{ name: t("marketing.card-manage"), path: "/marketing/card" }, { name: t("service.open-card") }];
  }
  get isAdd() {
    return this.$route.name === "cardOpen";
  }
  typeOptionsData: any = [
    {
      label: t("v210906.package-card"),
      value: "1"
    },
    {
      label: t("v210906.stored-value-card"),
      value: "2"
    }
  ];
  payWayList: any[] = [];
  get orderType() {
    return this.$route.query.type;
  }
  get urlCustomerCode() {
    return this.$route.query.customerCode;
  }
  serviceList: any[] = [];
  emptyToLine = emptyToLine;
  showSelectCustomer: boolean = false;
  orderFormData: any = {
    cardType: "1", // 卡类型1：套餐卡 2：储值卡
    cardTemplateCode: "", // 套餐模板code
    activatedDate: dayjs().format("YYYYMMDD"), // 开卡日期
    customerCode: "",
    mobile: "",
    firstName: ""
  };
  cardTemplateList: any = [];
  serviceItemList: any[] = [];
  cardTemplateInfo: any = {};
  get orderId() {
    return this.$route.params.id;
  }
  showPaymentMethodModal() {
    if (this.checkAddData()) {
      (this.$refs.orderForm as any).validate(valid => {
        if (valid) {
          this.showPaymentMethod = true;
        }
      });
    }
  }
  created() {
    this.setPBPX(52);
    this.init();
  }
  async init() {
    if (this.urlCustomerCode) {
      const urlCardType = this.$route.query.cardType;
      this.setCustomerData("", this.urlCustomerCode);
      if (urlCardType) {
        this.orderFormData.cardType = urlCardType;
        this.changeCardType();
      } else {
        this.getCardTemplateList();
      }
    } else {
      this.getCardTemplateList();
    }
    this.getPatternPaymentList({
      status: "1"
    }).then(data => {
      this.payWayList = (data?.data || []).filter(item => {
        return item.payMethodCode !== "6";
      });
    });
  }
  getCardTemplateList(cardTemplateName = "") {
    const { cardType } = this.orderFormData;
    this.queryCardTemplateList({
      pageNum: 1,
      pageSize: 20,
      status: 1,
      cardTemplateName,
      cardType
    }).then(data => {
      if (cardType === "2") {
        // 如果储值卡添加自定义模板选项
        this.cardTemplateList = [this.customizeOption, ...data.data.list];
      } else {
        this.cardTemplateList = data.data.list;
      }
    });
  }
  groupIndex: number = 1;
  handleCardTemplateChange(val) {
    if (val === this.customizeOption.cardTemplateCode) {
      this.cardTemplateInfo = {
        dateExpiry: t("marketing.permanent"),
        cardTemplateName: this.customizeOption.cardTemplateName
      };
      return;
    }
    this.groupIndex = 1;
    this.queryCardTemplateDetail({
      cardTemplateCode: val
    }).then(data => {
      data = data.data || { serviceList: [] };
      console.log("[ data ]", data);
      if (this.orderFormData.cardType === "1") {
        data.serviceList &&
          data.serviceList.forEach(serviceItem => {
            if (serviceItem.partsList && serviceItem.partsList.length > 0) {
              serviceItem.isGroup = true;
              serviceItem.groupServiceIndex = this.groupIndex;
              serviceItem.partsList.forEach(partsItem => {
                data.partsList.push(
                  Object.assign(partsItem, {
                    isGroup: true,
                    groupServiceIndex: this.groupIndex
                  })
                );
              });
              this.groupIndex++;
            }
          });
      }
      if (data.validPeriod === -1) {
        data.dateExpiry = t("marketing.permanent");
      } else {
        data.dateExpiry = dayjs().add(data.validPeriod, "d").format("YYYY-MM-DD");
      }
      this.cardTemplateInfo = data;
    });
  }
  submitForm() {
    if (!this.paymentMethod) {
      this.$message.error(t("v210831.please-select-payment"));
    } else {
      this.handleValidateAddCard();
    }
  }
  handleValidateAddCard() {
    this.validateAddCard(this.orderFormData).then(data => {
      if (data.data) {
        this.addCard();
      } else {
        this.openCardValidateMsg = data.message;
        this.showOpenCardValidate = true;
        this.showPaymentMethod = false;
      }
    });
  }
  orderFormRules: any = {
    cardAmount: {
      required: true,
      validator: (rule, value, callback) => {
        checkMoneyEl(value, callback);
      },
      trigger: "blur"
    },
    giftAmount: {
      validator: (rule, value, callback) => {
        checkMoneyEl(value, callback, true);
      },
      trigger: "blur"
    }
  };
  checkAddData(): boolean {
    if (!this.orderFormData.cardTemplateCode) {
      this.$message.error(t("v210906.please-select-a-card-template-first"));
      return false;
    }
    if (!this.orderFormData.customerCode) {
      this.$message.error(t("v210831.please-select-a-client"));
      return false;
    }
    return true;
  }
  addCard() {
    this.btnStartLoading();
    Object.assign(this.orderFormData, {
      paymentList: [
        {
          paidMethod: this.paymentMethod,
          paidAmount: this.cardTemplateInfo.cardAmount
        }
      ],
      cardAmount: this.cardTemplateInfo.cardAmount,
      giftAmount: this.cardTemplateInfo.giftAmount
    });
    this.createCard(this.orderFormData)
      .then(data => {
        this.$message.success(t("v210906.card-opening-succeeded"));
        this.queryCustomerCard({
          customerCode: this.orderFormData.customerCode,
          partsList: undefined,
          serviceList: undefined
        });
        this.$router.push(`/marketing/card-view/${data.data.cardCode}`);
        if (data.message) {
          const icon = require("@/assets/img/notice_info.png");
          this.$notify({
            title: "",
            customClass: "__global-message-notify",
            dangerouslyUseHTMLString: true,
            message: `<div class='disflex'>
            <div class='margin-right-8'><img class='width-24' src='${icon}'></div>
            <div>
            <p class='title notify-p1'>${t("v213.card-opening-notice")}</p>
            <p class='color-gray2 notify-p2'>${data.message}</p></div>
          </div>`,
            duration: 0,
            position: "bottom-right",
            onClick: () => {}
          });
        }
      })
      .finally(() => {
        this.btnStopLoading();
      });
  }

  deleteItem(key, index) {
    console.log(key, index);
    this.orderFormData[key].splice(index, 1);
  }

  linkCreateCustomer() {
    let { href } = this.$router.resolve({
      path: `/setting/customer-add`
    });
    window.open(href, "_blank");
  }

  seletedCustomerVehicleCode: string = "";
  customerList: any[] = [];
  handleShowSelCustomer() {
    this.showSelectCustomer = true;
    this.$nextTick(() => {
      (this.$refs["select-customer"] as any).focus();
    });
  }
  handleSearchCustomer(val) {
    if (val) {
      this.getCustomerList({
        pageSize: 20,
        pageNum: 1,
        searchKey: val
      }).then(data => {
        if (!data.data.list) {
          this.customerList = [];
        } else {
          this.customerList = data.data.list.map(item => {
            item.label = `${item.plateCode}${item.customerName ? "/" + item.customerName : ""} ${
              item.mobile ? "/" + item.mobile : ""
            }`;
            return item;
          });
        }
      });
    } else {
      this.customerList = [];
    }
  }

  handleChooseCustomer(val) {
    const customer = this.customerList.find(item => {
      return val === item.vehicleCode;
    });
    this.setCustomerData(val, customer?.customerCode);
  }
  customerVehicleList: any = [];
  setCustomerData(vehicleCode, customerCode) {
    this.orderFormData.customerCode = customerCode;
    this.getCustomerDetail({
      customerCode: customerCode,
      vehicleCode: vehicleCode
    }).then(data => {
      const customerData = data.data;
      this.customerVehicleList = data.data?.vehicleList || [];
      const mobileCheck = mobileRules(customerData.mobile);
      if (!customerData.customerName || !mobileCheck.success) {
        this.orderFormData.customerCode = "";
        this.seletedCustomerVehicleCode = "";
        this.$confirm(t("v210906.you-need-the-customers-name-and-mobile-phone"), t("v210831.tips"), {
          confirmButtonText: t("v210831.determine"),
          cancelButtonText: t("base.cancel"),
          type: "warning"
        })
          .then(() => {
            let { href } = this.$router.resolve({
              path: `/setting/customer-edit/${customerCode}?vehicleCode=${customerData.vehicleList[0].vehicleCode}`
            });
            window.open(href, "_blank");
          })
          .catch(() => {
            //
          });
      } else {
        this.orderFormData.firstName = customerData.customerName;
        this.orderFormData.mobile = customerData.mobile;
      }
    });
  }
  customizeOption: any = {
    cardTemplateCode: "CT_CUSTOMIZED_01",
    isCustomized: true,
    cardTemplateName: t("v213.custom-stored-value-card")
  };
  changeCardType() {
    this.orderFormData.cardTemplateCode = undefined;
    this.$refs.orderForm && (this.$refs.orderForm as any).clearValidate();
    this.getCardTemplateList();
  }
  get isCustomizeTemplate() {
    return this.orderFormData.cardTemplateCode === this.customizeOption.cardTemplateCode;
  }
  showPartsGroupPreview = false;
  partsRuleCode = "";
  partsRuleType = 2;
  groupName = "";
  handleGroupDetail(row) {
    this.showPartsGroupPreview = true;
    this.partsRuleCode = row.partsCode;
    this.partsRuleType = row.partsRuleType;
    this.groupName = row.partsName;
  }
}
